// extracted by mini-css-extract-plugin
export default {"work_environment_module_wrapper":"y_ZJXFigpZuDzaV0CPPD"};